module.exports = __webpack_public_path__ + "components/flag/static/square/bz-549f1682f459446962b1587c653cf599.svg";